<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/R6oitt/tc-custom/9783965375451.jpg" alt="This image is the cover for the book Forbidden Fruit, Erotics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden Fruit, Erotics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Forbidden Fruit is a classic Victorian erotic novel, published in 1898. It contains graphic sexual descriptions and themes. "Come into bed, and cuddle me, Percy, I feel so chilly to night, she whispered. Only too pleased I nestled myself by her side, still kissing and calling her my loving Auntie. Fate had ordained I was to lose my maidenhead that night, young as I was. Her hand passed all over me, caressing every part, and she freely abandoned her bosoms to my impassioned..."  (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anonymous Anonymous
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?088d1f9c